import { cn } from '@/shared/lib/utils'

export function getPlrCircleLabel(plr: string | null | undefined): string {
  if (plr == null || plr.trim() === '') {
    return '-'
  }
  const trimmed = plr.trim()
  const lastCharacter = trimmed.charAt(trimmed.length - 1)
  if (lastCharacter.length > 0) {
    return lastCharacter.toUpperCase()
  }
  return '-'
}

type PlrCircleBadgeProps = {
  plr: string | null | undefined
  className?: string
}

export function PlrCircleBadge({ plr, className }: PlrCircleBadgeProps) {
  return (
    <div
      className={cn(
        'flex size-10 items-center justify-center rounded-full bg-foreground text-lg font-bold text-background',
        className
      )}
    >
      {getPlrCircleLabel(plr)}
    </div>
  )
}
